import React, { createContext, useEffect, useState } from 'react';
import { map, get, isEmpty } from 'lodash';
import { any, object } from 'prop-types';
import moment from 'moment';
import { withApollo } from 'react-apollo';
import SessionService from '../auth/CacheService';

export const InvoicingDateRangeContext = createContext({});

const InvoicingDateRange = ({ children, client }) => {
    const initialState = {
        range: {
            init: `${moment().subtract(1, 'months').format('YYYY-MM-DD')} 00:00:00`,
            end: `${moment().add(1, 'days').format('YYYY-MM-DD')} 00:00:00`,
        }
    };

    const [date, setDate] = useState(initialState.range);
    const [initialSalesChannels, setInitialSalesChannels] = useState([]);
    const [salesChannels, setSalesChannels] = useState([]);

    useEffect(() => {
        setDate(initialState.range);
        setSalesChannels(initialSalesChannels);
    }, [window.location.pathname]);

    useEffect(async () => {
        SessionService.GetSession().then((res) => {
            const sessionSalesChannels = map(get(res, 'data.getUserInfo.salesChannels', []), ({ id }) => id);
            setInitialSalesChannels(sessionSalesChannels);
            setSalesChannels(sessionSalesChannels);
        });
    }, []);

    const setNewDate = ({ init, end }) => setDate({
        init: `${moment(init).format('YYYY-MM-DD')} 00:00:00`,
        end: `${moment(end).format('YYYY-MM-DD')} 00:00:00`
    });

    const { init, end } = date;

    if (isEmpty(salesChannels)) return null;
    return (
        <InvoicingDateRangeContext.Provider value={{ setDate: setNewDate, setSalesChannels, salesChannels, init, end }}>
            { children }
        </InvoicingDateRangeContext.Provider>
    );
};

InvoicingDateRange.propTypes = {
    children: any,
    client: object
};

export default withApollo(InvoicingDateRange);
